export const FEATURE_FLAG_KEYS = {
    enableChinaPayoutV2: "enable_china_pay_v2",
    enableNgnChinaPayout: "enable_ngn_china_payout",
    enableEditBeneficiary: "enable_edit_beneficiary",
    hideGhsSendButton: "hide_ghs_send_button", 
    virtualAccountsV2: "virtual-accounts-v2",
    enableStableCoins: "enable-stable-coins"
}
